import AuthTheme, { authColors } from '@/themes/AuthTheme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { PropsWithChildren } from 'react';
import logo_square from '../../../assets/images/logo-sqare.svg';

function Layout({ children }: PropsWithChildren) {
  return (
    <AuthTheme>
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          width: '100%',
        }}
      >
        {/* Left Panel - Dark with Logo */}
        <Box
          sx={(theme) => ({
            width: '50%',
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            [theme.breakpoints.down('md')]: {
              display: 'none',
            },
          })}
        >
          {/* Logo Container */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography
              variant="h3"
              sx={{
                color: authColors.panelText,
                fontWeight: 300,
                fontSize: '2.5rem',
                letterSpacing: '-0.02em',
              }}
            >
              Factory
            </Typography>
            <Box
              component="img"
              src={logo_square}
              alt="Factory QA Logo"
              sx={{
                height: 70,
                width: 'auto',
              }}
            />
          </Box>

          {/* Footer Copyright */}
          <Typography
            sx={{
              position: 'absolute',
              bottom: 24,
              left: 24,
              color: authColors.panelTextMuted,
              fontSize: '0.875rem',
            }}
          >
            © {new Date().getFullYear()} Factory QA. All rights reserved.
          </Typography>
        </Box>

        {/* Right Panel - Light gray with Form */}
        <Box
          sx={(theme) => ({
            width: '50%',
            backgroundColor: theme.palette.background.default,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(4),
            overflowY: 'auto',
            [theme.breakpoints.down('md')]: {
              width: '100%',
              minHeight: '100vh',
            },
          })}
        >
          {/* Mobile Logo - Only visible on smaller screens */}
          <Box
            sx={(theme) => ({
              display: 'none',
              marginBottom: theme.spacing(4),
              [theme.breakpoints.down('md')]: {
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              },
            })}
          >
            <Typography
              variant="h4"
              sx={(theme) => ({
                color: theme.palette.primary.main,
                fontWeight: 300,
              })}
            >
              Factory
            </Typography>
            <Box
              component="img"
              src={logo_square}
              alt="Factory QA Logo"
              sx={{
                height: 50,
                width: 'auto',
              }}
            />
          </Box>

          {/* Form Content */}
          <Box
            sx={{
              width: '100%',
              maxWidth: 420,
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </AuthTheme>
  );
}

export default Layout;
